import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CaseService } from '../../services/case.service';
import { LocalUserService } from '../../services/localUser';

@Component({
  selector: 'app-add-new-activity-dialog',
  templateUrl: './add-new-activity-dialog.component.html',
  styleUrls: ['./add-new-activity-dialog.component.scss']
})
export class AddNewActivityDialogComponent implements OnInit {
  loading: boolean;
  activity: string;
  constructor(
    public dialogRef: MatDialogRef<AddNewActivityDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
  }

  submit() {
    this.dialogRef.close(this.activity);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/main/shared/dialog/add-new-activity-dialog/add-new-activity-dialog.component.ts